
import {
  getDicByCountry,
  getDicByPositiona,
  getDicByPositionb,
  getDicByRegion,
  getDicByType,
  getDicByStatus,
  getDicByDownload,
  getDicByMainGroup,
  getDicByFormDelivery,
  getDicByEcoStatus,
  getDicByFunction,
  getDicByTradeFunction,
  getSegmentList,
  getDicByYear,
  getDicByBrandPos,
  getDicByPosPrice,
  getDicByLanguage,
  getApplications,
  getTradeCountry,
  getConsumerBenefits,
  getApproveUser,
  getSubmitBy,
  getUserListByName,
  getUserListByEmail,
  getMarketSegmentList,
  getCategory,
  getDicBySourcelist,
  getDicBySourceClaim,
  getDicByPlatfrom,
  getDicByDataType,
  getDicByTarget,
  getDicByUserType,
  getDicByMarketSegment,
  getDownloadAuth,
  getDisplayAuth,
  getFrontEndAuth,
  getRoleGeneralAuth,
  getDataManageAuth,
  getAppManageAuth,
  getDicByFunctionTarget,
  getUserStatus,
  getMessageSuggest,
  getDicByReleaseRegion,
  getDicByRegisterStatus,
  getDicByWhiteListUserType,
  getDicByAccountCountry,
  getPublicDicByAccountCountry,
  getDicBySource,
  getDicByFileLang,
  getDicByOriginUserType,
  getDicByPlatform,
  getDicBySubPlatform,
  getDicByDepartment,
  getPublicDicByDepartment,
  getDicByDeregistration,
  getSecondStatus,
  getPreference,
  getDicByPushModule,
  getDicByWebinarModule,
  getDicBySendStatus,
  getDicByMediaCategory,
  getDicByMediaLanguage,
  getDicByMediaSegment,
  getDicByMediaLifestyle,
  getDicByMediaOrder,
  getGoodsForms,
  getDicByProductFocus,
  getDicByTargetDemographicCare
} from '@/axios/api/dictionary'

const UPDATE_REGION_LIST = 'UPDATE_REGION_LIST'
const UPDATE_TYPE_LIST = 'UPDATE_TYPE_LIST'
const UPDATE_STATUS = 'UPDATE_STATUS_DIC'
const UPDATE_DOWNLOAD_LIST = 'UPDATE_DOWNLOAD_LIST'
const UPDATE_MAINGROUP_LIST = 'UPDATE_MAINGROUP_LIST'
const UPDATE_FORMDELIVERY_LIST = 'UPDATE_FORMDELIVERY_LIST'
const ECOSTATUS_LIST = 'ECOSTATUS_LIST'
const UPDATE_POSITION_LIST = 'UPDATE_POSITION_LIST'
const UPDATE_COUNTRY_LIST = 'UPDATE_COUNTRY_LIST'
const FUNCTION_LIST = 'FUNCTION_LIST'
const UPDATE_SEGMENT_LIST = 'UPDATE_SEGMENT_LIST'
const UPDATE_SECOND_LIST = 'UPDATE_SECOND_LIST'
const UPDATE_YEAR_LIST = 'UPDATE_YEAR_LIST'
const UPDATE_BRANDPOS_LIST = 'UPDATE_BRANDPOS_LIST'
const UPDATE_PRICEPOS_LIST = 'UPDATE_PRICEPOS_LIST'
const UPDATE_LANGUAGE_LIST = 'UPDATE_LANGUAGE_LISTS'
const UPDATE_APPLICATION_LIST = 'UPDATE_APPLICATION_LIST'
const UPDATE_TRADE_COUNTRY_LIST = 'UPDATE_TRADE_COUNTRY_LIST'
const UPDATE_CONSUMER_BENEFIT_LIST = 'UPDATE_CONSUMER_BENEFIT_LIST'
const UPDATE_APPROVE_USER = 'UPDATE_APPROVE_USER'
const UPDATE_SUBMIT_BY = 'UPDATE_SUBMIT_BY'
const UPDATE_USERLIST = 'UPDATE_USERLIST'
const UPDATE_SEARCH_FN = 'UPDATE_SEARCH_FN'
const UPDATE_MARKET_SEGMENT_LIST = 'UPDATE_MARKET_SEGMENT_LIST'
const UPDATE_CATEGPRY_LIST = 'UPDATE_CATEGPRY_LIST'
const UPDATE_SOURCE_LIST = 'UPDATE_SOURCE_LIST'
const UPDATE_SOURCE_CLAIM = 'UPDATE_SOURCE_CLAIM'
const UPDATE_PLATFROM = 'UPDATE_PLATFROM'
const UPDATE_DATATYPE = 'UPDATE_DATATYPE'
const UPDATE_TARGET = 'UPDATE_TARGET'
const UPDATE_USER_TYPE = 'UPDATE_USER_TYPE'
const UPDATE_MARKET_SEGMENT_CONCEPT = 'UPDATE_MARKET_SEGMENT_CONCEPT'
const UPDATE_TRADE_FUNCTION = 'UPDATE_TRADE_FUNCTION'
const UPDATE_TRADE_FUNCTION_SEARCH = 'UPDATE_TRADE_FUNCTION_SEARCH'
const UPDATE_DOWNLOAD_AUTH = 'UPDATE_DOWNLOAD_AUTH'
const UPDATE_DISPLAY_AUTH = 'UPDATE_DISPLAY_AUTH'
const UPDATE_FRONTEND_AUTH = 'UPDATE_FRONTEND_AUTH'
const UPDATE_ROLE_GENERAL_AUTH = 'UPDATE_ROLE_GENERAL_AUTH'
const UPDATE_DATA_MANAGE_AUTH = 'UPDATE_DATA_MANAGE_AUTH'
const UPDATE_APP_MANAGE_AUTH = 'UPDATE_APP_MANAGE_AUTH'
const UPDATE_FUNCTION_TARGET = 'UPDATE_FUNCTION_TARGET'
const UPDATE_USER_STATUS_LIST = 'UPDATE_USER_STATUS_LIST'
const UPDATE_GROUP_STATUS_LIST = 'UPDATE_GROUP_STATUS_LIST'
const UPDATE_MESSAGE_SUGGEST = 'UPDATE_MESSAGE_SUGGEST'
const UPDATE_RELEASE_REGION = 'UPDATE_RELEASE_REGION'
const UPDATE_WHITE_LIST_USER_TYPE = 'UPDATE_WHITE_LIST_USER_TYPE'
const UPDATE_REGISTER_STATUS = 'UPDATE_REGISTER_STATUS'
const UPDATE_ACCOUNT_COUNTRY_LIST = 'UPDATE_ACCOUNT_COUNTRY_LIST'
const UPDATE_PUBLIC_ACCOUNT_COUNTRY_LIST = 'UPDATE_PUBLIC_ACCOUNT_COUNTRY_LIST'
const UPDATE_SOURCE = 'UPDATE_SOURCE'
const UPDATE_FILE_LANG = 'UPDATE_FILE_LANG'
const UPDATE_ORIGIN_USER_TYPE = 'UPDATE_ORIGIN_USER_TYPE'
const UPDATE_PLATFORM_LIST = 'UPDATE_PLATFORM_LIST'
const UPDATE_SUB_PLATFORM = 'UPDATE_SUB_PLATFORM'
const UPDATE_DEPARTMENT = 'UPDATE_DEPARTMENT'
const UPDATE_PUBLIC_DEPARTMENT = 'UPDATE_PUBLIC_DEPARTMENT'
const UPDATE_DEREGISTRATION = 'UPDATE_DEREGISTRATION'
const UPDATE_SECOND_STATUS = 'UPDATE_SECOND_STATUS'
const UPDATE_PREFERENCE = 'UPDATE_PREFERENCE'
const UPDATE_PUSH_MODULE = 'UPDATE_PUSH_MODULE'
const UPDATE_WEBINAR_MODULE = 'UPDATE_WEBINAR_MODULE'
const UPDATE_SEND_STATUS = 'UPDATE_SEND_STATUS'
const UPDATE_MEDIA_CATEGORY = 'UPDATE_MEDIA_CATEGORY'
const UPDATE_MEDIA_LANGUAGE = 'UPDATE_MEDIA_LANGUAGE'
const UPDATE_MEDIA_SEGMENT = 'UPDATE_MEDIA_SEGMENT'
const UPDATE_MEDIA_LIFESTYLE = 'UPDATE_MEDIA_LIFESTYLE'
const UPDATE_MEDIA_ORDER = 'UPDATE_MEDIA_ORDER'
const UPDATE_MEDIA_GOODS_FORMS = 'UPDATE_MEDIA_GOODS_FORMS'
const UPDATE_PRODUCT_FOCUS = 'UPDATE_PRODUCT_FOCUS'
const UPDATE_TARGET_DEMOGRAPHIC_CARE = 'UPDATE_TARGET_DEMOGRAPHIC_CARE'

// 字典字段转换
function transform (arr) {
  return arr.map(v => {
    return { label: v.name, value: v.id }
  })
}

const state = {
  statusList: [],
  downloadList: [],
  regionList: [],
  typeList: [],
  mainGroupList: [],
  formDeliveryList: [],
  ecoStatusList: [],
  positionList: [],
  functionList: [],
  countryList: [],
  segmentList: [],
  secondList: [],
  yearList: [],
  brandPosList: [],
  pricePosList: [],
  languageList: [],
  applicationList: [],
  tradeCountryList: [],
  consumerBenefitList: [],
  approveUser: [],
  submitBy: [],
  userList: [],
  searchFn: [],
  marketSegment: [],
  categoryList: [],
  sourceList: [],
  sourceClaim: [],
  platform: [],
  dataType: [],
  target: [],
  userType: [],
  marketSegmentConcept: [],
  tradeFunction: [],
  tradeFunctionSearch: [],
  downloadAuth: [],
  displayAuth: [],
  frontEndAuth: [],
  roleGeneralAuth: [],
  dataManageAuth: [],
  appManageAuth: [],
  functionTarget: [],
  userStatusList: [],
  groupStatusList: [],
  messageSuggest: [],
  releaseRegion: [],
  registerStatus: [],
  whiteListUserType: [],
  accountCountryList: [],
  publicAccountCountryList: [],
  source: [],
  fileLang: [],
  originUserType: [],
  platformList: [],
  subPlatform: [],
  department: [],
  publicDepartment: [],
  deregistration: [],
  secondStatus: [],
  preference: [],
  pushModule: [],
  webinarModule: [],
  sendStatus: [],
  mediaCategory: [],
  mediaLanguage: [],
  mediaSegment: [],
  mediaLifestyle: [],
  mediaOrder: [],
  mediaGoodsForms: [],
  mediaYearList: [],
  productFocus: [],
  targetDemographicCare: []
}

const getters = {
  statusList: state => transform(state.statusList),
  downloadList: state => transform(state.downloadList),
  regionList: state => transform(state.regionList),
  typeList: state => transform(state.typeList),
  typeListConcept: state => state.typeList.map(v => {
    return {label: v.name, value: v.name}
  }),
  positionList: state => transform(state.positionList),
  countryList: state => transform(state.countryList),
  mainGroupList: state => state.mainGroupList.map(v => {
    return {label: v.mainGroupName, value: v.id}
  }),
  formDeliveryList: state => transform(state.formDeliveryList),
  ecoStatusList: state => state.ecoStatusList.map(v => {
    return { label: v.title, value: v.id, imgSrc: v.imgSrc } // 只传了中文
  }),
  functionList: state => state.functionList.map(v => {
    return { label: v.functionName, value: v.id }
  }),
  segmentList: state => transform(state.segmentList),
  secondList: state => transform(state.secondList),
  yearList: state => state.yearList.map(v => {
    return {
      ...v,
      label: Number(v.name),
      value: v.id
    }
  }),
  brandPosList: state => transform(state.brandPosList),
  pricePosList: state => transform(state.pricePosList),
  languageList: state => transform(state.languageList),
  applicationList: state => state.applicationList.map(v => {
    return { label: v.application, value: v.id }
  }),
  tradeCountryList: state => state.tradeCountryList.map(v => {
    return { label: v.countryName, value: v.id }
  }),
  consumerBenefitList: state => state.consumerBenefitList.map(v => {
    return { label: v.name, value: v.id }
  }),
  approveUser: state => state.approveUser.map(v => {
    return { label: v.account, value: v.id }
  }),
  submitBy: state => state.submitBy.map(v => {
    return { label: v.account, value: v.id }
  }),
  userList: state => state.userList,
  searchFn: state => state.searchFn.map(v => {
    return { label: v.functionName, value: v.id }
  }),
  marketSegment: state => transform(state.marketSegment),
  categoryList: state => transform(state.categoryList),
  sourceList: state => transform(state.sourceList),
  sourceClaim: state => transform(state.sourceClaim),
  platform: state => transform(state.platform),
  dataType: state => transform(state.dataType),
  target: state => transform(state.target),
  userType: state => transform(state.userType),
  marketSegmentConcept: state => transform(state.marketSegmentConcept),
  tradeFunction: state => state.tradeFunction.map(v => {
    return { label: v.tradeDisplayFunction, value: v.id }
  }),
  tradeFunctionSearch: state => state.tradeFunctionSearch.map(v => {
    return { label: v.tradeDisplayFunction, value: v.id }
  }),
  downloadAuth: state => transform(state.downloadAuth),
  displayAuth: state => transform(state.displayAuth),
  frontEndAuth: state => transform(state.frontEndAuth),
  roleGeneralAuth: state => transform(state.roleGeneralAuth),
  dataManageAuth: state => transform(state.dataManageAuth),
  appManageAuth: state => transform(state.appManageAuth),
  functionTarget: state => transform(state.functionTarget),
  userStatusList: state => state.userStatusList,
  groupStatusList: state => state.groupStatusList,
  messageSuggest: state => state.messageSuggest,
  releaseRegion: state => state.releaseRegion.map(v => {
    return {
      label: v.name,
      value: v.id
    }
  }),
  registerStatus: state => transform(state.registerStatus),
  whiteListUserType: state => transform(state.whiteListUserType),
  accountCountryList: state => transform(state.accountCountryList),
  publicAccountCountryList: state => transform(state.publicAccountCountryList),
  source: state => state.source.map(v => {
    return {
      ...v,
      label: v.name,
      value: v.id
    }
  }),
  fileLang: state => transform(state.fileLang),
  originUserType: state => state.originUserType.map(v => {
    return {
      label: v.name,
      value: v.id
    }
  }),
  platformList: state => state.platformList.map(v => {
    return {
      label: v.name,
      value: v.id
    }
  }),
  subPlatform: state => state.subPlatform.map(v => {
    return {
      label: v.name,
      value: v.id
    }
  }),
  department: state => transform(state.department),
  publicDepartment: state => transform(state.publicDepartment),
  deregistration: state => transform(state.deregistration),
  secondStatus: state => transform(state.secondStatus),
  preference: state => state.preference.map(v => {
    return {
      ...v,
      label: v.name,
      value: v.id
    }
  }),
  pushModule: state => transform(state.pushModule),
  webinarModule: state => transform(state.webinarModule),
  sendStatus: state => transform(state.sendStatus),
  mediaCategory: state => state.mediaCategory,
  mediaLanguage: state => transform(state.mediaLanguage),
  mediaSegment: state => transform(state.mediaSegment),
  mediaLifestyle: state => transform(state.mediaLifestyle),
  mediaOrder: state => state.mediaOrder.map(v => {
    return {
      ...v,
      label: v.name,
      value: v.id
    }
  }),
  mediaGoodsForms: state => transform(state.mediaGoodsForms),
  mediaYearList: state => state.mediaYearList.map(v => {
    return {
      ...v,
      label: Number(v.name),
      value: Number(v.name)
    }
  }),
  preferenceModule: state => state.preference
    .filter(v => v.type === 1)
    .map(v => {
      return {
        ...v,
        label: v.name,
        value: v.id
      }
    }),
  preferenceCategory: state => state.preference
    .filter(v => v.type === 2)
    .map(v => {
      return {
        ...v,
        label: v.name,
        value: v.id
      }
    }),
  productFocus: state => transform(state.productFocus),
  targetDemographicCare: state => transform(state.targetDemographicCare)
}

const mutations = {
  [UPDATE_STATUS] (state, statusList) {
    state.statusList = statusList
  },
  [UPDATE_DOWNLOAD_LIST] (state, downloadList) {
    state.downloadList = downloadList
  },
  [UPDATE_REGION_LIST] (state, regionList) {
    state.regionList = regionList
  },
  [UPDATE_TYPE_LIST] (state, typeList) {
    state.typeList = typeList
  },
  [UPDATE_MAINGROUP_LIST] (state, mainGroupList) {
    state.mainGroupList = mainGroupList
  },
  [UPDATE_FORMDELIVERY_LIST] (state, formDeliveryList) {
    state.formDeliveryList = formDeliveryList
  },
  [ECOSTATUS_LIST] (state, ecoStatusList) {
    state.ecoStatusList = ecoStatusList
  },
  [UPDATE_POSITION_LIST] (state, positionList) {
    state.positionList = positionList
  },
  [UPDATE_COUNTRY_LIST] (state, countryList) {
    state.countryList = countryList
  },
  [FUNCTION_LIST] (state, functionList) {
    state.functionList = functionList
  },
  [UPDATE_SEGMENT_LIST] (state, segmentList) {
    state.segmentList = segmentList
  },
  [UPDATE_SECOND_LIST] (state, secondList) {
    state.secondList = secondList
  },
  [UPDATE_YEAR_LIST] (state, yearList) {
    state.yearList = yearList
    state.mediaYearList = yearList
  },
  [UPDATE_BRANDPOS_LIST] (state, brandPosList) {
    state.brandPosList = brandPosList
  },
  [UPDATE_PRICEPOS_LIST] (state, pricePosList) {
    state.pricePosList = pricePosList
  },
  [UPDATE_LANGUAGE_LIST] (state, languageList) {
    state.languageList = languageList
  },
  [UPDATE_APPLICATION_LIST] (state, applicationList) {
    state.applicationList = applicationList
  },
  [UPDATE_TRADE_COUNTRY_LIST] (state, tradeCountryList) {
    state.tradeCountryList = tradeCountryList
  },
  [UPDATE_CONSUMER_BENEFIT_LIST] (state, consumerBenefitList) {
    state.consumerBenefitList = consumerBenefitList
  },
  [UPDATE_APPROVE_USER] (state, approveUser) {
    state.approveUser = approveUser
  },
  [UPDATE_SUBMIT_BY] (state, submitBy) {
    state.submitBy = submitBy
  },
  [UPDATE_USERLIST] (state, userList) {
    state.userList = userList
  },
  [UPDATE_SEARCH_FN] (state, searchFn) {
    state.searchFn = searchFn
  },
  [UPDATE_MARKET_SEGMENT_LIST] (state, marketSegment) {
    state.marketSegment = marketSegment
  },
  [UPDATE_CATEGPRY_LIST] (state, categoryList) {
    state.categoryList = categoryList
  },
  [UPDATE_SOURCE_LIST] (state, sourceList) {
    state.sourceList = sourceList
  },
  [UPDATE_SOURCE_CLAIM] (state, sourceClaim) {
    state.sourceClaim = sourceClaim
  },
  [UPDATE_PLATFROM] (state, platform) {
    state.platform = platform
  },
  [UPDATE_DATATYPE] (state, dataType) {
    state.dataType = dataType
  },
  [UPDATE_TARGET] (state, target) {
    state.target = target
  },
  [UPDATE_USER_TYPE] (state, userType) {
    state.userType = userType
  },
  [UPDATE_MARKET_SEGMENT_CONCEPT] (state, marketSegmentConcept) {
    state.marketSegmentConcept = marketSegmentConcept
  },
  [UPDATE_TRADE_FUNCTION] (state, tradeFunction) {
    state.tradeFunction = tradeFunction
  },
  [UPDATE_TRADE_FUNCTION_SEARCH] (state, tradeFunctionSearch) {
    state.tradeFunctionSearch = tradeFunctionSearch
  },
  [UPDATE_DOWNLOAD_AUTH] (state, downloadAuth) {
    state.downloadAuth = downloadAuth
  },
  [UPDATE_DISPLAY_AUTH] (state, displayAuth) {
    state.displayAuth = displayAuth
  },
  [UPDATE_FRONTEND_AUTH] (state, frontEndAuth) {
    state.frontEndAuth = frontEndAuth
  },
  [UPDATE_ROLE_GENERAL_AUTH] (state, roleGeneralAuth) {
    state.roleGeneralAuth = roleGeneralAuth
  },
  [UPDATE_DATA_MANAGE_AUTH] (state, dataManageAuth) {
    state.dataManageAuth = dataManageAuth
  },
  [UPDATE_APP_MANAGE_AUTH] (state, appManageAuth) {
    state.appManageAuth = appManageAuth
  },
  [UPDATE_FUNCTION_TARGET] (state, functionTarget) {
    state.functionTarget = functionTarget
  },
  [UPDATE_USER_STATUS_LIST] (state, userStatusList) {
    state.userStatusList = userStatusList
  },
  [UPDATE_GROUP_STATUS_LIST] (state, groupStatusList) {
    state.groupStatusList = groupStatusList
  },
  [UPDATE_MESSAGE_SUGGEST] (state, messageSuggest) {
    state.messageSuggest = messageSuggest
  },
  [UPDATE_RELEASE_REGION] (state, releaseRegion) {
    state.releaseRegion = releaseRegion
  },
  [UPDATE_WHITE_LIST_USER_TYPE] (state, whiteListUserType) {
    state.whiteListUserType = whiteListUserType
  },
  [UPDATE_REGISTER_STATUS] (state, registerStatus) {
    state.registerStatus = registerStatus
  },
  [UPDATE_ACCOUNT_COUNTRY_LIST] (state, accountCountryList) {
    state.accountCountryList = accountCountryList
  },
  [UPDATE_PUBLIC_ACCOUNT_COUNTRY_LIST] (state, publicAccountCountryList) {
    state.publicAccountCountryList = publicAccountCountryList
  },
  [UPDATE_SOURCE] (state, source) {
    state.source = source
  },
  [UPDATE_FILE_LANG] (state, fileLang) {
    state.fileLang = fileLang
  },
  [UPDATE_ORIGIN_USER_TYPE] (state, originUserType) {
    state.originUserType = originUserType
  },
  [UPDATE_PLATFORM_LIST] (state, platformList) {
    state.platformList = platformList
  },
  [UPDATE_SUB_PLATFORM] (state, subPlatform) {
    state.subPlatform = subPlatform
  },
  [UPDATE_DEPARTMENT] (state, department) {
    state.department = department
  },
  [UPDATE_PUBLIC_DEPARTMENT] (state, publicDepartment) {
    state.publicDepartment = publicDepartment
  },
  [UPDATE_DEREGISTRATION] (state, deregistration) {
    state.deregistration = deregistration
  },
  [UPDATE_SECOND_STATUS] (state, secondStatus) {
    state.secondStatus = secondStatus
  },
  [UPDATE_PREFERENCE] (state, preference) {
    state.preference = preference
  },
  [UPDATE_PUSH_MODULE] (state, pushModule) {
    state.pushModule = pushModule
  },
  [UPDATE_WEBINAR_MODULE] (state, webinarModule) {
    state.webinarModule = webinarModule
  },
  [UPDATE_SEND_STATUS] (state, sendStatus) {
    state.sendStatus = sendStatus
  },
  [UPDATE_MEDIA_CATEGORY] (state, mediaCategory) {
    state.mediaCategory = mediaCategory
  },
  [UPDATE_MEDIA_LANGUAGE] (state, mediaLanguage) {
    state.mediaLanguage = mediaLanguage
  },
  [UPDATE_MEDIA_SEGMENT] (state, mediaSegment) {
    state.mediaSegment = mediaSegment
  },
  [UPDATE_MEDIA_LIFESTYLE] (state, mediaLifestyle) {
    state.mediaLifestyle = mediaLifestyle
  },
  [UPDATE_MEDIA_ORDER] (state, mediaOrder) {
    state.mediaOrder = mediaOrder
  },
  [UPDATE_MEDIA_GOODS_FORMS] (state, mediaGoodsForms) {
    state.mediaGoodsForms = mediaGoodsForms
  },
  [UPDATE_PRODUCT_FOCUS] (state, productFocus) {
    state.productFocus = productFocus
  },
  [UPDATE_TARGET_DEMOGRAPHIC_CARE] (state, targetDemographicCare) {
    state.targetDemographicCare = targetDemographicCare
    console.log(state.targetDemographicCare)
  }
}

const actions = {
  async getStatusDic ({ state, commit }) {
    if (state.statusList.length) return
    try {
      let { data: res } = await getDicByStatus()
      commit(UPDATE_STATUS, res)
    } catch (e) { }
  },
  async getDownloadDic ({ state, commit }) {
    if (state.downloadList.length) return
    try {
      let { data: res } = await getDicByDownload()
      commit(UPDATE_DOWNLOAD_LIST, res)
    } catch (e) {}
  },
  async getRegionDic ({commit}) {
    if (state.regionList.length) return
    try {
      let { data: res } = await getDicByRegion()
      commit(UPDATE_REGION_LIST, res)
    } catch (e) {}
  },
  async getTypeDic ({commit}) {
    if (state.typeList.length) return
    try {
      let { data: res } = await getDicByType()
      commit(UPDATE_TYPE_LIST, res)
    } catch (e) {}
  },
  async getCountryDic ({commit}, isSort) {
    if (state.countryList.length) return
    try {
      let { data: res } = await getDicByCountry(isSort)
      commit(UPDATE_COUNTRY_LIST, res)
    } catch (e) {}
  },
  async getAccountCountryDic ({commit}) {
    if (state.accountCountryList.length) return
    try {
      let { data: res } = await getDicByAccountCountry()
      commit(UPDATE_ACCOUNT_COUNTRY_LIST, res)
    } catch (e) {}
  },
  async getPublicAccountCountryDic ({commit}) {
    try {
      let { data: res } = await getPublicDicByAccountCountry()
      commit(UPDATE_PUBLIC_ACCOUNT_COUNTRY_LIST, res)
      return true
    } catch (e) {
      return false
    }
  },
  async getPositionDic ({commit}) {
    if (state.positionList.length) return
    try {
      let { data: res1 } = await getDicByPositiona()
      let { data: res2 } = await getDicByPositionb()
      commit(UPDATE_POSITION_LIST, [...res1, ...res2])
    } catch (e) {}
  },
  async getMainGroupDic ({ state, commit }) {
    if (state.mainGroupList.length) return
    try {
      let { data: res } = await getDicByMainGroup()
      commit(UPDATE_MAINGROUP_LIST, res)
    } catch (e) { }
  },
  async getFormDeliveryDic ({ state, commit }) {
    if (state.formDeliveryList.length) return
    try {
      let { data: res } = await getDicByFormDelivery({pid1: 89}) // form of delivery
      commit(UPDATE_FORMDELIVERY_LIST, res)
    } catch (e) { }
  },
  async getEcoStatusDic ({ state, commit }) { // eco-status
    if (state.ecoStatusList.length) return
    try {
      let { data: res } = await getDicByEcoStatus()
      commit(ECOSTATUS_LIST, res)
    } catch (e) {}
  },
  // basf product 中 function 改为 tradeFunction
  async getTradeFunction ({state, commit}, params) {
    if (state.tradeFunction.length) return
    try {
      let { data: res } = await getDicByTradeFunction(params)
      commit(UPDATE_TRADE_FUNCTION, res)
    } catch (e) { }
  },
  // basf product 中 function 改为 tradeFunction
  async getTradeFunctionSearch ({commit}, params) {
    try {
      let { data: res } = await getDicByTradeFunction(params)
      commit(UPDATE_TRADE_FUNCTION_SEARCH, res)
    } catch (e) { }
  },
  async getFunctionList ({state, commit}) { // function
    if (state.functionList.length) return
    try {
      let { data: res } = await getDicByFunction()
      commit(FUNCTION_LIST, res)
    } catch (e) {}
  },
  async getSearchFn ({ commit }, params) {
    try {
      let { data: res } = await getDicByFunction(params)
      commit(UPDATE_SEARCH_FN, res)
    } catch (e) {}
  },
  async getSegmentDataApi ({state, commit}) {
    if (state.segmentList.length) return
    try {
      let { data: res } = await getSegmentList()
      commit(UPDATE_SEGMENT_LIST, res)
    } catch (e) {}
  },
  async getSecondDataApi ({commit}, params) {
    try {
      let { data: res } = await getSegmentList(params)
      commit(UPDATE_SECOND_LIST, res)
    } catch (e) {}
  },
  async getYearDic ({ state, commit }) {
    if (state.yearList.length) return
    try {
      let { data: res } = await getDicByYear()
      commit(UPDATE_YEAR_LIST, res)
    } catch (e) {}
  },
  async getBrandPosDic ({ state, commit }) {
    if (state.brandPosList.length) return
    try {
      let { data: res } = await getDicByBrandPos()
      commit(UPDATE_BRANDPOS_LIST, res)
    } catch (e) {}
  },
  async getPricePosDic ({ state, commit }) {
    if (state.pricePosList.length) return
    try {
      let { data: res } = await getDicByPosPrice()
      commit(UPDATE_PRICEPOS_LIST, res)
    } catch (e) {}
  },
  async getLanguageDic ({ state, commit }) {
    if (state.languageList.length) return
    try {
      let { data: res } = await getDicByLanguage()
      commit(UPDATE_LANGUAGE_LIST, res)
    } catch (e) {}
  },
  async getApplicationsDic ({ state, commit }) {
    if (state.applicationList.length) return
    try {
      let { data: res } = await getApplications()
      commit(UPDATE_APPLICATION_LIST, res)
    } catch (e) {}
  },
  async getTradeCountryDic ({ state, commit }) {
    if (state.tradeCountryList.length) return
    try {
      let { data: res } = await getTradeCountry()
      commit(UPDATE_TRADE_COUNTRY_LIST, res)
    } catch (e) {}
  },
  async getConsumerBenefitDic ({ state, commit }) {
    if (state.consumerBenefitList.length) return
    try {
      let { data: res } = await getConsumerBenefits()
      commit(UPDATE_CONSUMER_BENEFIT_LIST, res)
    } catch (e) {}
  },
  async getApproveUserApi ({ commit }, params) {
    try {
      let { data: res } = await getApproveUser(params)
      commit(UPDATE_APPROVE_USER, res)
    } catch (e) {}
  },
  async getSubmitByApi ({ commit }, params) {
    try {
      let { data: res } = await getSubmitBy(params)
      commit(UPDATE_SUBMIT_BY, res)
    } catch (e) {}
  },
  async getUserListByNameApi ({ commit }, params) {
    try {
      let { data: res } = await getUserListByName(params)
      commit(UPDATE_USERLIST, res)
      return res
    } catch (e) {
      commit(UPDATE_USERLIST, [])
    }
  },
  async getUserListByEmailApi ({ commit }, params) {
    try {
      let { data: res } = await getUserListByEmail(params)
      commit(UPDATE_USERLIST, res)
    } catch (e) {
      commit(UPDATE_USERLIST, [])
    }
  },
  async getMarketSegmentDic ({ state, commit }) {
    if (state.marketSegment.length) return
    try {
      let { data: res } = await getMarketSegmentList()
      commit(UPDATE_MARKET_SEGMENT_LIST, res)
    } catch (e) {}
  },
  async getCategoryDic ({ state, commit }) {
    if (state.categoryList.length) return
    try {
      let { data: res } = await getCategory()
      commit(UPDATE_CATEGPRY_LIST, res)
    } catch (e) {}
  },
  async getSourceListDic ({ state, commit }) {
    if (state.sourceList.length) return
    try {
      let { data: res } = await getDicBySourcelist()
      commit(UPDATE_SOURCE_LIST, res)
    } catch (e) {}
  },
  async getSourceClaimDic ({ state, commit }) {
    if (state.sourceClaim.length) return
    try {
      let { data: res } = await getDicBySourceClaim()
      commit(UPDATE_SOURCE_CLAIM, res)
    } catch (e) {}
  },
  async getPlatfromDic ({ state, commit }) {
    if (state.platform.length) return
    try {
      let { data: res } = await getDicByPlatfrom()
      commit(UPDATE_PLATFROM, res)
    } catch (e) {}
  },
  async getDataTypeDic ({ state, commit }) {
    if (state.dataType.length) return
    try {
      let { data: res } = await getDicByDataType()
      commit(UPDATE_DATATYPE, res)
    } catch (e) {}
  },
  async getTargetDic ({ state, commit }) {
    if (state.target.length) return
    try {
      let { data: res } = await getDicByTarget()
      commit(UPDATE_TARGET, res)
    } catch (e) {}
  },
  // getDicByUserType
  async getUserTypeDic ({ state, commit }) {
    if (state.userType.length) return
    try {
      let { data: res } = await getDicByUserType()
      commit(UPDATE_USER_TYPE, res)
    } catch (e) {}
  },
  async getMarketSegmentConceptDic ({ state, commit }, isSort) {
    if (state.marketSegmentConcept.length) return
    try {
      let { data: res } = await getDicByMarketSegment(isSort)
      commit(UPDATE_MARKET_SEGMENT_CONCEPT, res)
    } catch (e) {}
  },
  // 获取资源列表
  async getDownloadAuthDic ({ state, commit }) {
    if (state.downloadAuth.length) return
    try {
      let { data: res } = await getDownloadAuth()
      commit(UPDATE_DOWNLOAD_AUTH, res)
    } catch (e) {}
  },
  async getDisplayAuthDic ({ state, commit }) {
    if (state.displayAuth.length) return
    try {
      let { data: res } = await getDisplayAuth()
      commit(UPDATE_DISPLAY_AUTH, res)
    } catch (e) {}
  },
  async getFrontEndAuthDic ({ state, commit }) {
    if (state.frontEndAuth.length) return
    try {
      let { data: res } = await getFrontEndAuth()
      commit(UPDATE_FRONTEND_AUTH, res)
    } catch (e) {}
  },
  async getRoleGeneralAuthDic ({ state, commit }) {
    if (state.roleGeneralAuth.length) return
    try {
      let { data: res } = await getRoleGeneralAuth()
      commit(UPDATE_ROLE_GENERAL_AUTH, res)
    } catch (e) {}
  },
  async getDataManageAuthDic ({ state, commit }) {
    if (state.dataManageAuth.length) return
    try {
      let { data: res } = await getDataManageAuth()
      commit(UPDATE_DATA_MANAGE_AUTH, res)
    } catch (e) {}
  },
  async getAppManageAuthDic ({ state, commit }) {
    if (state.appManageAuth.length) return
    try {
      let { data: res } = await getAppManageAuth()
      commit(UPDATE_APP_MANAGE_AUTH, res)
    } catch (e) {}
  },
  async getFunctionTargetDic ({ state, commit }) {
    if (state.functionTarget.length) return
    try {
      let { data: res } = await getDicByFunctionTarget()
      commit(UPDATE_FUNCTION_TARGET, res)
    } catch (e) {}
  },
  async getUserStatusDic ({ state, commit }, params) {
    // if (state.userStatusList.length) return
    try {
      let { data: res } = await getUserStatus(params)
      commit(UPDATE_USER_STATUS_LIST, res)
    } catch (e) {}
  },
  async getMessageSuggestDic ({ state, commit }) {
    if (state.messageSuggest.length) return
    try {
      let { data: res } = await getMessageSuggest()
      commit(UPDATE_MESSAGE_SUGGEST, res)
    } catch (e) {}
  },
  async getDicByReleaseRegionApi ({ state, commit }) {
    try {
      let { data: res } = await getDicByReleaseRegion()
      commit(UPDATE_RELEASE_REGION, res)
    } catch (e) {}
  },
  async getRegisterStatus ({state, commit}) {
    if (state.registerStatus.length) return
    try {
      let { data: res } = await getDicByRegisterStatus()
      commit(UPDATE_REGISTER_STATUS, res)
    } catch (e) {}
  },
  async getWhiteListUserType ({state, commit}) {
    if (state.whiteListUserType.length) return
    try {
      let { data: res } = await getDicByWhiteListUserType()
      commit(UPDATE_WHITE_LIST_USER_TYPE, res)
    } catch (e) {}
  },
  async getDicBySourceApi ({state, commit}) {
    if (state.source.length) return
    try {
      let { data: res } = await getDicBySource()
      commit(UPDATE_SOURCE, res)
    } catch (e) {}
  },
  async getDicByFileLangApi ({state, commit}) {
    if (state.fileLang.length) return
    try {
      let { data: res } = await getDicByFileLang()
      commit(UPDATE_FILE_LANG, res)
    } catch (e) {}
  },
  async getDicByOriginUserTypeApi ({state, commit}) {
    if (state.originUserType.length) return
    try {
      let { data: res } = await getDicByOriginUserType()
      commit(UPDATE_ORIGIN_USER_TYPE, res)
    } catch (e) {}
  },
  async getDicByPlatformApi ({state, commit}) {
    if (state.platformList.length) return
    try {
      let { data: res } = await getDicByPlatform()
      commit(UPDATE_PLATFORM_LIST, res)
    } catch (e) {}
  },
  async getDicBySubPlatformApi ({state, commit}) {
    if (state.subPlatform.length) return
    try {
      let { data: res } = await getDicBySubPlatform()
      commit(UPDATE_SUB_PLATFORM, res)
    } catch (e) {}
  },
  async getDicByPushModuleApi ({state, commit}) {
    if (state.pushModule.length) return
    try {
      let { data: res } = await getDicByPushModule()
      commit(UPDATE_PUSH_MODULE, res)
    } catch (e) {}
  },
  async getDicByWebinarModuleApi ({state, commit}) {
    if (state.webinarModule.length) return
    try {
      let { data: res } = await getDicByWebinarModule()
      commit(UPDATE_WEBINAR_MODULE, res)
    } catch (e) {}
  },
  async getDicBySendStatusApi ({state, commit}) {
    if (state.sendStatus.length) return
    try {
      let { data: res } = await getDicBySendStatus()
      commit(UPDATE_SEND_STATUS, res)
    } catch (e) {}
  },
  async getDicByMediaCategoryApi ({state, commit}) {
    if (state.mediaCategory.length) return
    try {
      let { data: res } = await getDicByMediaCategory()
      commit(UPDATE_MEDIA_CATEGORY, res)
    } catch (e) {}
  },
  async getDicByMediaLanguageApi ({state, commit}) {
    if (state.mediaLanguage.length) return
    try {
      let { data: res } = await getDicByMediaLanguage()
      commit(UPDATE_MEDIA_LANGUAGE, res)
    } catch (e) {}
  },
  async getDicByMediaSegmentApi ({state, commit}) {
    if (state.mediaSegment.length) return
    try {
      let { data: res } = await getDicByMediaSegment()
      commit(UPDATE_MEDIA_SEGMENT, res)
    } catch (e) {}
  },
  async getDicByMediaLifestyleApi ({state, commit}) {
    if (state.mediaLifestyle.length) return
    try {
      let { data: res } = await getDicByMediaLifestyle()
      commit(UPDATE_MEDIA_LIFESTYLE, res)
    } catch (e) {}
  },
  async getDicByMediaOrderApi ({state, commit}) {
    if (state.mediaOrder.length) return
    try {
      let { data: res } = await getDicByMediaOrder()
      commit(UPDATE_MEDIA_ORDER, res)
    } catch (e) {}
  },
  async getGoodsFormsApi ({state, commit}) {
    if (state.mediaGoodsForms.length) return
    try {
      let { data: res } = await getGoodsForms()
      commit(UPDATE_MEDIA_GOODS_FORMS, res)
    } catch (e) {}
  },
  async getDicByDepartmentApi ({state, commit}) {
    if (state.department.length) return
    try {
      let { data: res } = await getDicByDepartment()
      commit(UPDATE_DEPARTMENT, res)
    } catch (e) {}
  },
  async getPublicDicByDepartmentApi ({state, commit}) {
    try {
      let { data: res } = await getPublicDicByDepartment()
      commit(UPDATE_PUBLIC_DEPARTMENT, res)
      return true
    } catch (e) {
      return false
    }
  },
  async getDicByDeregistrationApi ({state, commit}) {
    if (state.deregistration.length) return
    try {
      let { data: res } = await getDicByDeregistration()
      commit(UPDATE_DEREGISTRATION, res)
    } catch (e) {}
  },
  async getSecondStatusApi ({state, commit}) {
    if (state.secondStatus.length) return
    try {
      let { data: res } = await getSecondStatus()
      commit(UPDATE_SECOND_STATUS, res)
    } catch (e) {}
  },
  async getPreferenceApi ({state, commit}) {
    if (state.preference.length) return
    try {
      const { data: res } = await getPreference()
      commit(UPDATE_PREFERENCE, res)
    } catch (e) {}
  },
  async getDicByProductFocusApi ({ state, commit }) {
    if (state.productFocus.length) return
    try {
      let { data: res } = await getDicByProductFocus()
      commit(UPDATE_PRODUCT_FOCUS, res)
    } catch (e) {}
  },
  async getDicByTargetDemographicCareApi ({ state, commit }) {
    if (state.targetDemographicCare.length) return
    try {
      let { data: res } = await getDicByTargetDemographicCare()
      commit(UPDATE_TARGET_DEMOGRAPHIC_CARE, res)
    } catch (e) {}
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dictionary.js